import { sendFlc } from 'api';
import useAxios from 'hooks/useAxios';
import { IFLCRequest } from '../../server/types';

const useFlc = () => {
  const [request, { loading, error }] = useAxios<IFLCRequest>();

  const handleFlc = async (data: IFLCRequest) => {
    const flc = await request(sendFlc(data));

    return flc;
  };

  return [handleFlc, { loading, error: error?.data?.message }] as const;
};

export { useFlc };
